import _ from 'lodash'

// const redirect = function ({isServer, isClient, res, error}, path, status = 307) {
//   if (isClient && window && window.location) {
//     // this.$router.go(`/wedding/${this.$store.state.wedding.slug}/login/`)
//     window.location.href = path
//     error({ statusCode: status, message: `Redirecting to ${path}` })
//   } else if (isServer) {
//     // this.$router.go(`/wedding/${this.$store.state.wedding.slug}/login/`)
//     res.setHeader('Location', path)
//     error({ statusCode: status, message: `Redirecting to ${path}` })
//   }
// }

export default function (ctx) {
  const {store, route} = ctx
  let redirectLoginPath = `/editor/noaccess/`

  switch (route.name) {
    default:

      if (store?.state?.user?.session.uid === undefined || store.state.user.session.uid === null) {
        // if session is missing then no access is allowed - we only allow logged in users
        // #### NO ACCESS ######
        // redirect(ctx, redirectLoginPath)
        ctx.redirect(redirectLoginPath)
      } else if (store.state.user.session.is_event_admin === true) {
        // #### ACCESS GRANTED ######
        // IF THIS IS ADMIN of the event then we are letting them in
        break
      }

      // #### ACCESS GRANTED ######
      break
  }
}
